import { useAxios } from 'packages/core'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { refreshRequestOrRequestItem } from './utils'

export const useClaim = (page, requestId, requestItemId) => {
    const callApi = useAxios()
    const queryClient = useQueryClient()

    return useMutation(
        (stepId) =>
            callApi({
                method: 'POST',
                url: `/api/delegations/claim/${stepId}`,
            }),
        {
            onSettled: () =>
                refreshRequestOrRequestItem(
                    page,
                    requestId,
                    requestItemId,
                    queryClient,
                ),
        },
    )
}

export const useUnclaim = (page, requestId, requestItemId) => {
    const callApi = useAxios()
    const queryClient = useQueryClient()

    return useMutation(
        (stepId) =>
            callApi({
                method: 'POST',
                url: `/api/delegations/unclaim/${stepId}`,
            }),
        {
            onSettled: () =>
                refreshRequestOrRequestItem(
                    page,
                    requestId,
                    requestItemId,
                    queryClient,
                ),
        },
    )
}

export const useAssign = (page, requestId, requestItemId) => {
    const callApi = useAxios()
    const queryClient = useQueryClient()

    return useMutation(
        (data) =>
            callApi({
                method: 'POST',
                url: `/api/delegations/assign/${data.stepId}/${data.personId}`,
            }),
        {
            onSettled: () =>
                refreshRequestOrRequestItem(
                    page,
                    requestId,
                    requestItemId,
                    queryClient,
                ),
        },
    )
}

export const useAddAdditionalApprovers = (
    page,
    requestId,
    requestItemId,
    stepId,
) => {
    const callApi = useAxios()
    const queryClient = useQueryClient()
    let url =
        page === 'Requests'
            ? `/api/Delegations/addApproversForBusinessRequest/${requestId}`
            : `/api/delegations/addApprovers/${stepId}`
    return useMutation(
        (data) =>
            callApi({
                method: 'POST',
                url,
                data,
            }),
        {
            onSettled: () =>
                refreshRequestOrRequestItem(
                    page,
                    requestId,
                    requestItemId,
                    queryClient,
                ),
        },
    )
}

export const useCreatePermanentStepDelegation = (
    page,
    requestId,
    requestItemId,
) => {
    const callApi = useAxios()

    return useMutation(
        (data) =>
            callApi({
                method: 'POST',
                url: '/api/delegations/createDelegation',
                data,
            }),
        {
            onSettled: () =>
                refreshRequestOrRequestItem(page, requestId, requestItemId),
        },
    )
}
export const useHasAccessToAddApprovers = (personId) => {
    const callApi = useAxios()
    return useQuery(
        ['HAS_ACCESS_TO_ADD_APPROVERS', personId],
        () =>
            callApi({
                method: 'GET',
                url: `/api/Delegations/hasAccessToAddApprover/${personId}`,
            }).then((data) => data.data),
        {
            enabled: Boolean(personId),
        },
    )
}
export const useAddApproverForOpenSteps = (page, requestId, requestItemId) => {
    const callApi = useAxios()
    const queryClient = useQueryClient()

    return useMutation(
        (data) =>
            callApi({
                method: 'POST',
                url: `/api/BusinessRequests/setApproverForAllCurrentOpenItemSteps/${requestId}/${data}`,
            }),
        {
            onSettled: () =>
                refreshRequestOrRequestItem(
                    page,
                    requestId,
                    requestItemId,
                    queryClient,
                ),
        },
    )
}
